// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2hL-N","list":"PatternAutocomplete_list__2FC08"};